const DOT_SUBSTITUTE = '__DOT__';

export const replaceKey = (key: string, from: RegExp = /\./g, to: string = DOT_SUBSTITUTE) => {
  return key.replace(from, to);
};

export const restoreKey = (key: string, from: RegExp = new RegExp(DOT_SUBSTITUTE, 'g'), to: string = '.') => {
  return key.replace(from, to);
};
